<div *ngIf="isLoading()" class="spinner-wrapper" aria-hidden="true">
    <nz-spin nzSimple [nzSize]="'large'" nzTip="Loading..."></nz-spin>
</div>